import {get} from "lodash"
import BaseService from "./Base"

class TermsServiceV2 extends BaseService {
    async getAllTerms(params = {}) {
        const response = await this.post("/v2/terms/list", params)
        return get(response, "data", [])
    }

    async getAllTermYears(params = {}) {
        const response = await this.post("/v2/terms/list-calendar-years", params)
        return get(response, "data", [])
    }

    async exportAsCsv(data) {
        const response = await this.post(`/v2/terms/export-as-csv`, data, {
            responseType: "blob"
        })
        return get(response, "data", null)
    }
}

export default TermsServiceV2
